import * as zod from 'zod'

export const detailsSchema = zod.object({
  assignmentName: zod
    .string()
    .min(1, {
      message: 'Please enter an Assignment Name',
    })
    .max(50, {
      message: 'Please limit the assignment name to 50 characters',
    })
    .optional(),
  locationId: zod.number({
    required_error: 'Please select a Location',
  }),
  positionId: zod.number({
    required_error: 'Please select a Position',
  }),
  isBillRate: zod.boolean().optional(),
  billRateId: zod.number().optional(),
  billRate: zod.coerce.number().optional(),
  expectedMileage: zod.coerce
    .number()
    .nonnegative('Please enter a valid mileage')
    .int('Please enter a whole number')
    .optional(),
  confirmOrderLocations: zod.boolean().optional(),
  locationless: zod.boolean().default(false),
  acknowledgeTryoutList: zod
    .literal(true, {
      errorMap: () => ({
        message: "Please check the checkbox in the 'Acknowledge List' section.",
      }),
    })
    .optional(),
})

export type DetailsForm = zod.infer<typeof detailsSchema>
